var map = {
	"./Reading.png": "R3l9",
	"./Reading@2x.png": "5y55",
	"./answer@2x.png": "gEUJ",
	"./bg_baoti@2x.png": "9vte",
	"./bg_mingshi@2x.png": "I3dK",
	"./bg_vip@2x.png": "US/L",
	"./collect@2x.png": "uEOS",
	"./correct.png": "C+Lo",
	"./file-read-1480.png": "EtXj",
	"./finance.png": "+fiR",
	"./free@2x.png": "Py2n",
	"./frequency-b@2x.png": "rRoH",
	"./frequency-icon@2x.png": "VWy6",
	"./gotoquestion悬停2x.png": "xH+A",
	"./gotoquestion正常2x.png": "GxE3",
	"./huangguan@2x.png": "06OV",
	"./icon-testReport-active@2x.png": "jSL/",
	"./icon@2x.png": "m1Cq",
	"./icon_baogao@3x.png": "FHQ2",
	"./icon_dan_lv@2x.png": "t+eB",
	"./icon_dan_lv@3x.png": "XUb+",
	"./icon_danxiang@3x.png": "r2Ww",
	"./icon_danxiang_b@2x.png": "a3dW",
	"./icon_dui@3x.png": "4Lni",
	"./icon_fanlu@2x.png": "sVYS",
	"./icon_henhao@2x.png": "lWZ0",
	"./icon_jicha@2x.png": "p7yI",
	"./icon_jihao@2x.png": "CVek",
	"./icon_jinxz@2x.png": "iVuW",
	"./icon_kemu@2x.png": "dlIz",
	"./icon_kouyu@3x.png": "cC13",
	"./icon_kouyu_lv@3x.png": "Ki5G",
	"./icon_nan@2x.png": "R1ia",
	"./icon_shuju_lv@3x.png": "qLmL",
	"./icon_shun_lv@2x.png": "YV7j",
	"./icon_shun_lv@3x.png": "Z809",
	"./icon_shunxu@3x.png": "nVfD",
	"./icon_shunxu_b@2x.png": "OahZ",
	"./icon_ticai@3x.png": "ShUO",
	"./icon_ticai_b@2x.png": "EAHY",
	"./icon_ticai_lv@2x.png": "zT54",
	"./icon_ticai_lv@3x.png": "5FZY",
	"./icon_tingli@3x.png": "NOOb",
	"./icon_tingli_lv@3x.png": "hP8X",
	"./icon_wancheng@2x.png": "YzmL",
	"./icon_weilx@2x.png": "+Zmy",
	"./icon_xiezuo@3x.png": "AqaE",
	"./icon_xiezuo_lv@3x.png": "9BeB",
	"./icon_yi@2x.png": "KoKd",
	"./icon_yiban@2x.png": "FtZn",
	"./icon_yuedu@3x.png": "3x2I",
	"./icon_yuedu_lv@3x.png": "XhpL",
	"./icon_zhong@2x.png": "fa2f",
	"./icon_zidian.png": "9bIX",
	"./icon_zidian@2x.png": "NlCt",
	"./icon_zidian_pre.png": "H49O",
	"./icon_zidian_pre@2x.png": "KCt/",
	"./logo彩@2x.png": "zbDI",
	"./microphone.png": "bmgG",
	"./move@2x.png": "XEuu",
	"./other@2x.png": "j8EF",
	"./questions@2x.png": "c/Xs",
	"./return悬停2x.png": "aBGp",
	"./return正常2x.png": "9jc1",
	"./setting@2x.png": "14nH",
	"./u5.png": "KySK",
	"./updates@2x.png": "dBsW",
	"./user@2x.png": "LIa0",
	"./vip-router@2x.png": "335B",
	"./vip@2x.png": "wRIO",
	"./vip_bai@2x.png": "8h6t",
	"./vip_h@2x.png": "6BrM",
	"./浏览试题悬停@2x.png": "xLr/",
	"./笔.png": "A/6J",
	"./笔@2x.png": "pTxL",
	"./组 12.png": "SsjG",
	"./耳机.png": "AU+1",
	"./耳机@2x.png": "nbXO"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Pw20";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newUi-icon ^\.\/.*\.png$
// module id = Pw20
// module chunks = 96